<template>
	<div class="flex-grow-1">
		<v-row>
			<template v-for="filter in mainFilters">
				<v-col cols="auto">
					<template v-if="filter.type === 'select'">
						<v-select
								v-model="filters[filter.key]"
								class="rounded-lg "
								:clearable="filter.clearable"
								:dense="$vuetify.breakpoint.smAndDown"
								hide-details
								:item-value="filter.bindValue || 'id'"
								:item-text="filter.bindText || 'name'"
								:items="filter.data"
								:label="filter.name"
								:menu-props="{ maxHeight: filter.maxWindowHeight || '400' }"
								:multiple="filter.multiselect"
								outlined
								style="max-width: 320px;flex: 0 1 auto;"
								v-on:change="emitOnChange ? filterChanged() : ''"
						>
						</v-select>
					</template>
					<template v-if="filter.type === 'checkbox'">
						<v-checkbox
							v-model="filters[filter.key]"
							class="rounded-lg ironclad-checkbox"
							:dense="$vuetify.breakpoint.smAndDown"
							:value="filter.default || false"
							:label="filter.name"
							v-on:change="emitOnChange ? filterChanged() : ''"
						></v-checkbox>
					</template>
					<template v-else-if="filter.type === 'dateSelector'">
						<v-dialog
								ref="dateFilterDialog"
								v-model="dateModal"
								persistent
								:return-value.sync="dates"
								width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
										v-model="dates"
										v-bind="attrs"
										append-icon="mdi-calendar"
										class="rounded-lg"
										:dense="$vuetify.breakpoint.smAndDown"
										hide-details
										:label="filter.name"
										outlined
										readonly
										style="max-width: 320px;"
										v-on="on"
								></v-text-field>
							</template>
							<v-date-picker
									v-model="dates"
									no-title
									:range="filter.range"
									:type="filter.dateType"
							>
								<v-spacer></v-spacer>
								<v-btn color="primary" text @click="dateModal = false">
									Cancel
								</v-btn>
								<v-btn
										color="primary"
										text
										@click="applyDates(dates, filter)"
								>
									OK
								</v-btn>
							</v-date-picker>
						</v-dialog>
					</template>
					<template v-else>

					</template>
				</v-col>
			</template>
		</v-row>
		<v-row v-if="hasFilter && showButtons">
			<v-spacer v-if="$vuetify.breakpoint.mdAndUp" class="align-self-center">
				<v-divider class="opacity-30"></v-divider>
			</v-spacer>
			<v-col class="align-center d-flex" cols="auto">
				<!-- Reset Filters -->
				<v-btn
						class="rounded-lg"
						color="grey lighten-3"
						depressed
						:small="$vuetify.breakpoint.smAndDown"
						@click="resetData"
				>
					<v-icon
							v-if="$vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xsOnly"
							:class="{
							  'me-2': $vuetify.breakpoint.smAndUp,
							  'ms-n1': $vuetify.breakpoint.smAndUp
							}"
					>
						mdi-history
					</v-icon>
					<span v-if="$vuetify.breakpoint.smAndUp">Reset</span>
				</v-btn>
			</v-col>
			<v-col class="align-center d-flex pl-0" cols="auto">
				<!-- Reset Filters -->
				<v-btn
						class="rounded-lg"
						color="primary"
						depressed
						:small="$vuetify.breakpoint.smAndDown"
						@click="filterChanged"
				>
					<span v-if="$vuetify.breakpoint.smAndUp">Search</span>
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>

	export default {
		name: 'BwFilters',
		props: {
			displayFilters: {
				type: Object,
				required: true
			},
			emitOnChange: {
				type: Boolean,
				required: false,
				default: false
			},
			filters: {
				type: Object,
				required: false,
				default: () => {
					return {};
				}
			},
			showButtons: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		data() {
			return {
				dateModal: false,
				dates:[],
				signalUpdateDates:false,
			};
		},
		computed: {
			mainFilters: {
				get() {
					let displayFilters = []
					Object.keys(this.displayFilters).forEach(key => {
						if (this.displayFilters[key].position === 'main') {
							if(this.displayFilters[key].type === 'dateSelector'
									&& !!this.displayFilters[key].range !== Array.isArray(this.dates)
							) {
								this.$set(this, 'dates', this.displayFilters[key].range ? [] : '');
							}
							if( !this.displayFilters[key].key )
								this.displayFilters[key].key = key;
							//if filterEmpty is set, then we need to add a blank option to the select
							if(this.displayFilters[key].filterEmpty) {
								let emptyOption = {
									id: -1,
									name: this.displayFilters[key].filterEmpty
								}
								this.displayFilters[key].data.unshift(emptyOption)
							}
							displayFilters.push(this.displayFilters[key])
						}
					});
					displayFilters = displayFilters.sort((a, b) => a.sort - b.sort)
					return displayFilters
				}
			},
			hasFilter() {
				return !_.isEmpty(this.filters);
			}
		},
		mounted() {
		},
		methods: {
			filterChanged() {
				this.$emit('filters-changed', this.filters);
			},
			resetData() {
				this.$emit('reset-data', this.filters);
			},
			applyDates(dates, filter) {
				if (dates && Array.isArray(dates)) {
					this.filters.startDateTime =
						moment(dates[0])
							.startOf('day')
							.format('YYYY-MM-DD HH:mm:ss')
					;
					this.filters.endDateTime =
						moment(dates[1] || dates[0])
							.endOf('day')
							.format('YYYY-MM-DD HH:mm:ss')
					;
				} else {
					this.$set(this.filters, filter.key, moment(dates).format('YYYY-MM-DD HH:mm:ss'));
				}

				this.$refs.dateFilterDialog[0].save(dates);
			}
		},
		watch: {
			'filters.startDateTime': function (n) {
				if(n) Vue.set(this.dates, 0, moment(n).format('YYYY-MM-DD'));
			},
			'filters.endDateTime': function (n) {
				if(n) Vue.set(this.dates, 1, moment(n).format('YYYY-MM-DD'));
			},
			'filters.month': function (n) {
				if(n) Vue.set(this, 'dates', moment(n).format('YYYY-MM'));
			},
		}
	};
</script>

<style lang="scss" scoped>
	@use "sass:color";
	@import '~vuetify/src/styles/styles.sass';
	@import '~vuetify/src/styles/settings/_variables';

	.v-select--is-multi .v-select__selections {
		flex-wrap: nowrap !important;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;
	}

	.filter-menu-btn {
		position: absolute;
		right: 0;
		top: 5px;
	}
</style>
